export const mockData = [
    {
        Bname: 'eilat',
        agents: 'חזי',
        amount_dv: 5,
        amount_pay: 0,
        amount_tn: 1,
        baseOrder: undefined,
        baseValue: undefined,
        category: '',
        city: '',
        clients: [4, 15, 18, 318, 319],
        cnotes2: '',
        cnotes3: '',
        cnotes4: '',
        comments: '',
        contact: '',
        contact2: '',
        contact3: '',
        date_contact: '00-00-0000',
        days_to_pay: 0,
        group: '',
        id: 318,
        type: 'חשבונית מס קבלה',
        mdate_carteset: '2025-01-13',
        date: new Date('2025-01-13'),
        name: 'eilat',
        net: 5,
        nkObject: { lastVisit_4s1f28$_0: null, city: '', street: '', streetNumber: '', entityDated: null },
        notes_open: 682,
        obligo: 0,
        openSumDue: 6240435.52,
        overdue_tax_notes: 205,
        payment_notes: '',
        phone: '0508313310',
        phone2: '',
        phone3: '',
        taxNotes_open: 206,
        value_carteset: 6233432.93,
        value_dv: 1781,
        value_left: 0,
        value_pay: 0,
        value_tn: 2080
    },
    {
        Bname: 'jerusalem',
        agents: 'דוד',
        amount_dv: 3,
        type: 'חשבונית מס',
        amount_pay: 0,
        amount_tn: 2,
        baseOrder: undefined,
        baseValue: undefined,
        category: '',
        city: '',
        clients: [20, 25, 28, 320, 321],
        cnotes2: '',
        cnotes3: '',
        cnotes4: '',
        comments: '',
        contact: '',
        contact2: '',
        contact3: '',
        date_contact: '00-00-0000',
        days_to_pay: 0,
        group: '',
        id: 320,
        mdate_carteset: '2025-01-14',
        date: new Date('2025-01-14'),
        name: 'jerusalem',
        net: 3,
        nkObject: { lastVisit_4s1f28$_0: null, city: '', street: '', streetNumber: '', entityDated: null },
        notes_open: 480,
        obligo: 0,
        openSumDue: 7240435.75,
        overdue_tax_notes: 215,
        payment_notes: '',
        phone: '0528313320',
        phone2: '',
        phone3: '',
        taxNotes_open: 210,
        value_carteset: 7233432.75,
        value_dv: 1581,
        value_left: 0,
        value_pay: 0,
        value_tn: 2000
    },
    {
        Bname: 'telaviv',
        agents: 'רוני',
        amount_dv: 4,
        amount_pay: 0,
        amount_tn: 3,
        baseOrder: undefined,
        baseValue: undefined,
        date: new Date('2025-01-15'),
        category: '',
        city: '',
        type: 'חשבונית מס',
        clients: [30, 35, 38, 330, 339],
        cnotes2: '',
        cnotes3: '',
        cnotes4: '',
        comments: '',
        contact: '',
        contact2: '',
        contact3: '',
        date_contact: '00-00-0000',
        days_to_pay: 0,
        group: '',
        id: 330,
        mdate_carteset: '2025-01-15',
        name: 'telaviv',
        net: 4,
        nkObject: { lastVisit_4s1f28$_0: null, city: '', street: '', streetNumber: '', entityDated: null },
        notes_open: 550,
        obligo: 0,
        openSumDue: 8240435.88,
        overdue_tax_notes: 225,
        payment_notes: '',
        phone: '0538313330',
        phone2: '',
        phone3: '',
        taxNotes_open: 215,
        value_carteset: 8233432.88,
        value_dv: 1881,
        value_left: 0,
        value_pay: 0,
        value_tn: 2150
    },
    {
        Bname: 'haifa',
        agents: 'משה',
        amount_dv: 6,
        amount_pay: 0,
        amount_tn: 1,
        baseOrder: undefined,
        baseValue: undefined,
        category: '',
        city: '',
        clients: [40, 45, 48, 418, 419],
        cnotes2: '',
        cnotes3: '',
        cnotes4: '',
        comments: '',
        contact: '',
        contact2: '',
        contact3: '',
        type: 'חוב',
        date_contact: '00-00-0000',
        days_to_pay: 0,
        group: '',
        id: 418,
        mdate_carteset: '2025-01-16',
        date: new Date('2025-01-16'),
        name: 'haifa',
        net: 6,
        nkObject: { lastVisit_4s1f28$_0: null, city: '', street: '', streetNumber: '', entityDated: null },
        notes_open: 690,
        obligo: 0,
        openSumDue: 9240435.99,
        overdue_tax_notes: 235,
        payment_notes: '',
        phone: '0548313340',
        phone2: '',
        phone3: '',
        taxNotes_open: 220,
        value_carteset: 9233432.99,
        value_dv: 1981,
        value_left: 0,
        value_pay: 0,
        value_tn: 2250
    },
    {
        Bname: 'beer sheva',
        agents: 'יוסי',
        amount_dv: 2,
        type: 'חוב',
        amount_pay: 0,
        amount_tn: 4,
        baseOrder: undefined,
        baseValue: undefined,
        category: '',
        city: '',
        clients: [50, 55, 58, 518, 519],
        cnotes2: '',
        cnotes3: '',
        cnotes4: '',
        comments: '',
        contact: '',
        contact2: '',
        contact3: '',
        date_contact: '00-00-0000',
        days_to_pay: 0,
        group: '',
        id: 518,
        mdate_carteset: '2025-01-17',
        date: new Date('2025-01-17'),
        name: 'beer sheva',
        net: 2,
        nkObject: { lastVisit_4s1f28$_0: null, city: '', street: '', streetNumber: '', entityDated: null },
        notes_open: 700,
        obligo: 0,
        openSumDue: 10240435.0,
        overdue_tax_notes: 245,
        payment_notes: '',
        phone: '0558313350',
        phone2: '',
        phone3: '',
        taxNotes_open: 230,
        value_carteset: 10233432.0,
        value_dv: 1681,
        value_left: 0,
        value_pay: 0,
        value_tn: 2350
    }
];

export const manualEntryMock = [
    {
        date: new Date('2020-01-01'),
        receipts: [
            {
                id: 'receipt-001',
                date: new Date('2020-01-01'),
                price: '123'
            },
            {
                id: 'receipt-002',
                date: new Date('2020-01-01'),
                price: 10
            }
        ]
    },
    {
        date: new Date('2020-02-01'),
        receipts: [
            {
                id: 'receipt-003',
                date: new Date('2020-02-01'),
                price: '123'
            },
            {
                id: 'receipt-004',
                date: new Date('2020-02-01'),
                price: 10
            },
            {
                id: 'receipt-005',
                date: new Date('2020-02-01'),
                price: ''
            },
            {
                id: 'receipt-006',
                date: new Date('2020-02-01'),
                price: 0
            }
        ]
    }
];
